import useComment from './useComment'
import useCompanyContribution from './useCompanyContribution'
import useTribute from './useTribute'

// Aggregates the per-section hooks behind the donor-facing "extras"
// block — the optional metadata that hangs between the Contact form
// and the action button (data sharing, company contribution, tribute,
// and whatever else lands here later). Mounted once at the App level
// so each section's state survives panel transitions; the resulting
// `extras` object is then passed as a single prop into ContactStep,
// ExpressCheckout, and useRecord.
//
// Aggregating buys us:
//   - one `extras.draftOrderProps()` spread in useRecord instead of
//     remembering to add each new section's draftOrderProps as more
//     opt-in fields land
//   - a single namespaced surface for adding the next section without
//     touching Contact/ExpressCheckout/useRecord again

// `tribute` arg is the partner config (e.g. { enable_tribute: true,
// tribute_types: ['honor', 'memory'] }) — rename it locally so the
// rest of the hook can use the unqualified `tribute` for the
// useTribute return value (matches how DonationExtras / consumers
// see it on extras.tribute).
const useDonationExtras = ({
  order, tribute: tributeConfig = {},
  collect_business_name, postDonationComment,
}) => {
  const tribute = useTribute({ tribute: tributeConfig, order })
  const companyContribution = useCompanyContribution({
    order, enabled: !!collect_business_name,
  })
  const comment = useComment({ enabled: !!postDonationComment })

  const draftOrderProps = () => ({
    ...tribute.draftOrderProps(),
    ...companyContribution.draftOrderProps(),
    ...comment.draftOrderProps(),
  })

  return { tribute, companyContribution, comment, draftOrderProps }
}

export default useDonationExtras
